import { HFlow } from 'bold-ui'
import { ExposedDropdown } from 'components/dropdown/ExposedDropdown'
import { OrdemRegulacaoEnum } from 'graphql/types.generated'

import { ListaRegulacaoFilterModel } from '../model-regulacao'

interface ListaRegulacaoSortDropdownProps {
  filter: ListaRegulacaoFilterModel
  updateFilter(filter: ListaRegulacaoFilterModel): void
}

const RegulacaoSortMap: Record<OrdemRegulacaoEnum, string> = {
  [OrdemRegulacaoEnum.ATUALIZACOES_REGULACAO_MAIS_RECENTES]: 'Atualizações de regulação mais recentes',
  [OrdemRegulacaoEnum.ATUALIZACOES_REGULACAO_MAIS_ANTIGAS]: 'Atualizações de regulação mais antigas',
  [OrdemRegulacaoEnum.SOLICITACOES_MAIS_RECENTES]: 'Solicitações mais recentes',
  [OrdemRegulacaoEnum.SOLICITACOES_MAIS_ANTIGAS]: 'Solicitações mais antigas',
  [OrdemRegulacaoEnum.PRIORIDADE_CRESCENTE]: 'Prioridade crescente',
  [OrdemRegulacaoEnum.PRIORIDADE_DECRESCENTE]: 'Prioridade decrescente',
}

const itemToString = (sort: OrdemRegulacaoEnum) => sort && RegulacaoSortMap[sort]

export function ListaRegulacaoSortDropdown(props: Readonly<ListaRegulacaoSortDropdownProps>) {
  const { updateFilter, filter } = props

  const tableFilter = filter.tableFilter

  const onChangeSelect = (sort: OrdemRegulacaoEnum) => {
    updateFilter({
      ...filter,
      tableFilter: {
        ...tableFilter,
        ordem: sort,
      },
    })
  }

  return (
    <HFlow hSpacing={0.25} alignItems='center' justifyContent='flex-end'>
      <ExposedDropdown<OrdemRegulacaoEnum>
        label='Ordenar por:'
        selectedItem={tableFilter.ordem}
        items={Object.keys(RegulacaoSortMap) as OrdemRegulacaoEnum[]}
        itemToString={itemToString}
        onChange={onChangeSelect}
      />
    </HFlow>
  )
}
